import axios from 'axios'
import {Message} from './types'
import endpoints from '../../endpoints'
import {transformMsgResponse} from './service'

const API_URL = process.env.REACT_APP_API_URL || ''

export async function fetchMessages({
  pageParam = 0,
  limit = 10,
}: {
  pageParam: number
  limit: number
}): Promise<{data: Message[]; hasMore: boolean}> {
  try {
    const response = await axios.put(API_URL + endpoints.parentMessages.list, {
      type: 'admin',
      offset: pageParam * limit,
      limit,
    })

    const data = transformMsgResponse(response.data.data)

    return {data, hasMore: data.length === limit}
  } catch (error) {
    console.error('Error fetching messages:', error)
    throw error
  }
}

export async function sendMessage(body: any): Promise<Message> {
  try {
    const response = await axios.post(API_URL + endpoints.parentMessages.create, body)
    return response.data
  } catch (error) {
    console.error('Error sending message:', error)
    throw error
  }
}

export async function deleteMessage(msgId: Message['id']) {
  try {
    const response = await axios.delete(API_URL + endpoints.parentMessages.delete + msgId)
    return response.data
  } catch (error) {
    throw error
  }
}
